
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
axios.defaults.baseURL = API_BASE;

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('voter_token');
    const savedUser = localStorage.getItem('voter_user');
    if (token && savedUser) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  // login: supports both Name+Phone (field workers) and Email+Password (super admin)
  const login = async (email, password, name, phone) => {
    let body = {};
    if (name && phone) {
      body = { name, phone };        // Name + Phone (client app)
    } else if (email && password) {
      body = { email, password };    // Email + Password (super admin)
    }
    const { data } = await axios.post('/auth/login', body);
    localStorage.setItem('voter_token', data.token);
    localStorage.setItem('voter_user', JSON.stringify(data.user));
    axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
    setUser(data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('voter_token');
    localStorage.removeItem('voter_user');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{
      user, login, logout, loading,
      isAdmin: ['admin', 'superadmin'].includes(user?.role),
      isSuperAdmin: user?.role === 'superadmin',
      isUser: user?.role === 'user'
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { axios };
// isUser already covered - any logged in person